import { render } from "./SiteHeroDefault.vue?vue&type=template&id=38c7b2a4&scoped=true"
import script from "./SiteHeroDefault.vue?vue&type=script&lang=js"
export * from "./SiteHeroDefault.vue?vue&type=script&lang=js"

import "./SiteHeroDefault.vue?vue&type=style&index=0&id=38c7b2a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c7b2a4"]])

export default __exports__